import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
  "@global": {
    body: {
      overflow: (props: any) => (props.show ? "hidden" : "auto"),
    },
  },
  complaintPopupOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.7)",
    zIndex: 999,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  complaintPopupContainer: {
    position: "fixed",
    background: "#f9fafb",
    left: 100,
    top: 80,
    right: 100,
    bottom: 48,
    padding: "20px 24px 80px",
    overflow: "auto",
    borderRadius: "5px",
    border: "2px solid #e8e8e8",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
    borderTopRightRadius: "5px",
    borderTopLeftRadius: "5px",
  },
  popupTitle: {
    position: "fixed",
    borderBottom: "1px solid #e8e8e8",
    left: 100,
    top: 80,
    right: 100,
    background: "linear-gradient(135deg, #fff 0%, #f9fafb 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "16px 24px",
    border: "2px solid #e8e8e8",
    borderTopRightRadius: "5px",
    borderTopLeftRadius: "5px",
    zIndex: 1000,
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
    "& h6": {
      padding: "0px",
      fontWeight: "700!important" as any,
      fontSize: "1.3rem",
      color: "#02906f",
    },
  },
  closeButton: {
    cursor: "pointer",
    color: "#6b7280",
    fontSize: "28px",
    fontWeight: 300,
    width: "32px",
    height: "32px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    transition: "all 0.2s ease",
    "&:hover": {
      color: "#ef4444",
      backgroundColor: "#fee2e2",
    },
  },
  section: {
    marginTop: "20px",
    padding: "20px",
    border: "1px solid #e8e8e8",
    borderRadius: "10px",
    backgroundColor: "#f9fafb",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
    "& h6": {
      color: "#02906f",
      fontWeight: "700!important" as any,
      marginBottom: "10px",
      fontSize: "1.1rem!important",
    },
  },
  detailRow: {
    display: "flex",
    flexDirection: "column",
    marginBottom: "0",
    padding: "6px 12px",
    backgroundColor: "#fff",
    borderRadius: "8px",
    border: "1px solid #e8e8e8",
    transition: "all 0.3s ease",
    "&:hover": {
      boxShadow: "0 2px 8px rgba(2, 144, 111, 0.15)",
      borderColor: "#02906f",
    },
    "& label": {
      fontWeight: 600,
      fontSize: "0.75rem",
      color: "#777",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
      marginBottom: "6px",
    },
    "& span": {
      color: "#333",
      fontSize: "0.95rem",
      fontWeight: 500,
      wordBreak: "break-word",
    },
  },
  infoCard: {
    backgroundColor: "#fff",
    borderRadius: "10px",
    padding: "20px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
    border: "1px solid #e8e8e8",
    marginBottom: "20px",
  },
  infoCardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
    paddingBottom: "12px",
    borderBottom: "2px solid #e8e8e8",
    "& h6": {
      color: "#02906f!important",
      fontWeight: "700!important" as any,
      fontSize: "1.1rem!important",
      margin: "0!important",
    },
  },
  statusBadge: {
    padding: "4px 12px",
    borderRadius: "20px",
    fontSize: "0.85rem",
    fontWeight: 600,
    textAlign: "center",
    display: "inline-block",
  },
  costHighlight: {
    fontSize: "1.1rem!important",
    fontWeight: "700!important" as any,
    color: "#02906f!important",
  },
  divider: {
    height: "1px",
    backgroundColor: "#e8e8e8",
    margin: "20px 0",
  },
  tableContainer: {
    marginTop: "0",
    border: "1px solid #e8e8e8",
    borderRadius: "8px",
    overflow: "hidden",
    backgroundColor: "#fff",
    "& table": {
      width: "100%",
      borderCollapse: "collapse",
    },
    "& th": {
      backgroundColor: "#02906f",
      color: "#fff",
      padding: "14px 16px",
      textAlign: "left",
      fontWeight: 600,
      fontSize: "0.9rem",
      letterSpacing: "0.3px",
      textTransform: "uppercase",
    },
    "& td": {
      padding: "14px 16px",
      borderBottom: "1px solid #f0f0f0",
      fontSize: "0.9rem",
      color: "#333",
    },
    "& tbody tr": {
      transition: "background-color 0.2s ease",
      "&:hover": {
        backgroundColor: "#f8f9fa",
      },
    },
    "& tr:last-child td": {
      borderBottom: "none",
    },
  },
  actionButtons: {
    position: "fixed",
    left: 100,
    right: 100,
    bottom: 48,
    background: "#FFF",
    padding: "15px 20px",
    display: "flex",
    gap: "12px",
    justifyContent: "flex-end",
    borderBottomLeftRadius: "5px",
    borderBottomRightRadius: "5px",
    border: "2px solid #e8e8e8",
    borderTop: "1px solid #e8e8e8",
    zIndex: 1000,
    boxShadow: "0 -2px 10px rgba(0, 0, 0, 0.05)",
  },
});

export default useStyles;
